import { Vector3 } from 'three';

import { FNode, FNodeTypesEnum, outlineFromNode } from '@spazious/dollhouse-fsetup';
import { isPointInNavMesh, NavMeshQuery } from '@spazious/dollhouse-navmesh';

const _point = new Vector3();

export const NODES_PLACEMENT_ERROR = 'Furniture are placed out of the space';

export const validateNodesPlacement = (
  nodes: FNode[],
  navMeshQuery?: NavMeshQuery
): { valid: boolean; error?: string } => {
  if (!navMeshQuery) return { valid: true };

  let success = true;
  for (let node of nodes) {
    const corners = outlineFromNode(node);
    // a composition without an outline has no placeable nodes left at this
    // position (its layout got fully clipped out of the navmesh)
    if (node.type === FNodeTypesEnum.FComposition && corners.length === 0) {
      success = false;
      break;
    }
    if (!corners.every((p) => isPointInNavMesh(_point.set(p[0], 0, p[1]), navMeshQuery))) {
      success = false;
      break;
    }
  }

  return { valid: success, error: success ? '' : NODES_PLACEMENT_ERROR };
};
